import { SvgIcon , SvgIconProps} from '@mui/material';
import './ccf-thumbs-down-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfThumbsDownIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfThumbsDownIcon(props: CcfThumbsDownIconProps) {
  return (
    <SvgIcon
      {...props}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M15.7991 0H4.3421C3.71047 0.000210514 3.09891 0.221858 2.61381 0.626379C2.12872 1.0309 1.80079 1.59269 1.6871 2.214L0.5441 8.514C0.472882 8.9032 0.48807 9.30329 0.588591 9.68596C0.689112 10.0686 0.872509 10.4245 1.1258 10.7285C1.3791 11.0325 1.6961 11.277 2.05437 11.4449C2.41265 11.6128 2.80344 11.6999 3.1991 11.7H7.2991L6.7991 12.987C6.58949 13.5504 6.51967 14.1563 6.59561 14.7526C6.67156 15.349 6.89101 15.918 7.23515 16.4109C7.57929 16.9038 8.03784 17.3059 8.57149 17.5826C9.10514 17.8594 9.69795 18.0026 10.2991 18C10.4722 17.9996 10.6416 17.9494 10.7868 17.8552C10.9321 17.761 11.0471 17.6269 11.1181 17.469L13.6851 11.7H15.7991C16.5152 11.7 17.2019 11.4155 17.7083 10.9092C18.2146 10.4028 18.4991 9.71608 18.4991 9V2.7C18.4991 1.98392 18.2146 1.29716 17.7083 0.790812C17.2019 0.284464 16.5152 0 15.7991 0ZM12.1991 10.612L9.7521 16.12C9.50186 16.0442 9.26978 15.918 9.07012 15.7492C8.87046 15.5803 8.70746 15.3724 8.59112 15.1383C8.47479 14.9041 8.40759 14.6486 8.39366 14.3875C8.37972 14.1264 8.41935 13.8652 8.5101 13.62L8.9871 12.333C9.0895 12.0604 9.12424 11.7671 9.08834 11.4781C9.05245 11.1891 8.94698 10.9132 8.78099 10.6739C8.61501 10.4347 8.39346 10.2393 8.13535 10.1045C7.87724 9.96969 7.59029 9.89952 7.2991 9.9H3.1991C3.06693 9.89904 2.93652 9.86956 2.8168 9.81356C2.69707 9.75756 2.59085 9.67637 2.50539 9.57553C2.41994 9.4747 2.35727 9.3566 2.32166 9.22931C2.28606 9.10202 2.27836 8.96854 2.2991 8.838L3.4421 2.538C3.48044 2.32834 3.59194 2.13909 3.75675 2.00394C3.92156 1.86879 4.12899 1.79652 4.3421 1.8H12.1991V10.612ZM16.6991 9C16.6991 9.2387 16.6043 9.46761 16.4355 9.6364C16.2667 9.80518 16.0378 9.9 15.7991 9.9H13.9991V1.8H15.7991C16.0378 1.8 16.2667 1.89482 16.4355 2.0636C16.6043 2.23239 16.6991 2.4613 16.6991 2.7V9Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CcfThumbsDownIcon;
